export const downloadPostData = (blob: Blob, extension = 'csv') => {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `data.${extension}`
  link.click()
}

export const injectStyle = (id: string, textContent: string) => {
  let style = document.getElementById(id) as HTMLStyleElement | null
  if (!style) {
    style = document.createElement('style')
    style.setAttribute('id', id)
    document.getElementsByTagName('head')[0].appendChild(style)
  }
  if (textContent) {
    style.textContent = textContent
  }
  return style
}
export const addClassToBody = (classNames: string) => {
  document.body.classList.add(...classNames.split(' ').filter(Boolean))
}
